export const VERSION = '4.2.4-gogreen';
export const GIT_HASH = 'c9eac6e66fe2887a389b15efdfaafc057f9070bf';
export const BUILD_DATE = '';
